/* 🤖 this file was generated by svg-to-ts */
export const iccIconFile: {
  name: 'file';
  data: string;
} = {
  name: 'file',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="M14.25 1h-9c-1.237 0-2.239.99-2.239 2.2L3 20.8C3 22.01 4.001 23 5.239 23H18.75c1.238 0 2.25-.99 2.25-2.2V7.6L14.25 1Zm-9 19.8V3.2h7.875v5.5h5.625v12.1H5.25Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h24v24H0z"/></clipPath></defs></svg>`
};
